import { render } from "./CustomerTab.vue?vue&type=template&id=7706f778&scoped=true&ts=true"
import script from "./CustomerTab.vue?vue&type=script&lang=ts"
export * from "./CustomerTab.vue?vue&type=script&lang=ts"

import "./CustomerTab.vue?vue&type=style&index=0&id=7706f778&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7706f778"]])

export default __exports__